import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DropDown from "../../Components/Shared/Dropdown/Dropdown";
import FormInputs from "../../Components/Shared/FormInputs/FormInputWithoutValidations";
import SelectedValuesDropdown from "../../Components/Shared/SelectedValuesDropdown/SelectDropdown";
import searchicon from "../../Assets/Images/CommanImages/searchyellow.png";
import ErrorImg from "../../Assets/Images/CommanImages/Warning.png";
import { GET, POST } from "../../Api/HttpsMethods";
import EndPoints from "../../Api/Endpoints";
import SubscriberSearchDropdown from "./SubscriberSearchDropdown";
import "./SendNotification.css";

const SendNotification = ({ dataClient, setMessageBox, setIsMessageBoxVisible, setActiveImg }) => {
  const navigate = useNavigate();
  const [isScheduleOpen, setIsScheduleOpen] = useState(true);
  const [selectedCoursePlan, setSelectedCoursePlan] = useState(null);
  const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [msgText, setMsgText] = useState("");
  const [message, setMessage] = useState("");
  const [isSubscription, setIsSubscription] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
  const [planTypeId, setPlanTypeId] = useState(1);
  const [subscriberTypeId, setSubscriberTypeId] = useState(1);
  const [subscriberId, setSubscriberId] = useState(null);
  const [subscriberSearchKey, setSubscriberSearchKey] = useState("");
  const [subscriberList, setSubscriberList] = useState([]);
  const [coursePlanOptions, setCoursePlanOptions] = useState([]);

  useEffect(() => {
    fetchCoursePlans();
  }, []);

  const fetchCoursePlans = async () => {
    try {
      const response = await GET.withToken(EndPoints.GET_ALL_COURSE_PLANS);
      if (response?.data) {
        const plans = response.data.map((item) => ({
          label: item.course_plan_name,
          id: item.course_plan_id,
        }));
        setCoursePlanOptions(plans);
      }
    } catch (error) {
      console.error("Failed to fetch course plans:", error);
    }
  };

  const fetchSubscribersBySearch = async (searchKey) => {
    try {
      const params = new URLSearchParams();
      params.append("search_key", searchKey);
      if (planTypeId === 2 && selectedCoursePlan?.id) {
        params.append("course_plan_id", selectedCoursePlan.id);
      }

      const response = await GET.withToken(
        `${EndPoints.GET_SUBSCRIBER_DETAILS_BY_SEARCH_KEY}?${params.toString()}`
      );

      if (response?.data) {
        const mapped = response.data.map((item) => ({
          id: item.subscriber_id,
          label: item.subscriber_name,
          communication_number: item.communication_number,
          course_name: item.course_name,
          class_name: item.class_name,
          plan_name: item.plan_name,
          status: item.status,
          firebase_id: item.firebase_id,
        }));
        setSubscriberList(mapped);
      } else {
        setSubscriberList([]);
      }
    } catch (error) {
      console.error("Failed to fetch subscribers:", error);
      setSubscriberList([]);
    }
  };

  const proceedSend = async (currentMsgText, currentMessage, currentSubscriberList) => {
    const selectedSubscriber =
      subscriberTypeId === 2 && subscriberId
        ? currentSubscriberList.find((s) => s.id === subscriberId)
        : null;

    const payload = {
      title: currentMsgText,
      body: currentMessage,
      data: {},
      firebase_id: selectedSubscriber?.firebase_id ?? null,
    };

    setIsMessageBoxVisible(true);
    setActiveImg(null);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Sending notification, please wait...</span>
        </div>
      </div>
    );

    const response = await POST.withToken(EndPoints.SEND_PUSH_NOTIFICATION, payload);

    if (response?.status === "success") {
      setIsMessageBoxVisible(true);
      setActiveImg(null);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Notification sent successfully!</span>
          </div>
        </div>
      );
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Failed to send notification. Please try again.</span>
          </div>
        </div>
      );
    }
  };

  const handlePushNotification = async () => {
    if (planTypeId === 2 && !selectedCoursePlan) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a Course Plan before sending.</span>
          </div>
        </div>
      );
      return;
    }

    if (!message.trim()) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please enter a Message before sending.</span>
          </div>
        </div>
      );
      return;
    }

    if (subscriberTypeId === 2 && !subscriberId) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a Subscriber before sending.</span>
          </div>
        </div>
      );
      return;
    }

    // NEW: No title — show Yes/No confirm via setMessageBox
    if (!msgText.trim()) {
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>No title entered. Do you want to send without a title?</span>
          </div>
          <div className="messagebox-btn-container" style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={async () => {
                setIsMessageBoxVisible(false);
                await proceedSend(msgText, message, subscriberList);
              }}
            >
              YES
            </button>
            <button
              className="messagebox-cancel-btn-ok"
              onClick={() => {
                setIsMessageBoxVisible(false);
              }}
            >
              NO
            </button>
          </div>
        </div>
      );
      return;
    }

    await proceedSend(msgText, message, subscriberList);
  };

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Send Push Notification</span>
        <div className="create-test-section-btns-container-ques-paper-dels">
          {/* <button className="create-test-section-btn-ques-paper-del">
            CANCEL
          </button> */}
          <button
            className="create-test-section-btn-ques-paper-del"
            onClick={handlePushNotification}
          >
            SEND
          </button>
        </div>
      </div>
      <div className="display-ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>Notifications Details</label>
          </div>
          <div
            className="accordion-btn"
            onClick={() => setIsScheduleOpen((o) => !o)}
          >
            {isScheduleOpen ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>
        {isScheduleOpen && (
          <div className="accordion-content">
            <div className="display-test-data-container-ques-paper-del-filter-tags">
              <div className="display-grid-container-ques-paper-del-filter-tags">

                {/* Plan Type Radios */}
                <div style={{ display: "flex", gap: "120px" }}>
                  {[
                    { id: 1, label: "All Plans" },
                    { id: 2, label: "Specific Plan" },
                  ].map((type) => (
                    <label
                      key={type.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        color: "#6A6A6A",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        value={type.id}
                        checked={planTypeId === type.id}
                        onChange={() => {
                          setPlanTypeId(type.id);
                          if (type.id === 1) {
                            setSelectedCoursePlan(null);
                            setSubscriberList([]);
                            setSubscriberId(null);
                          }
                        }}
                      />
                      <div style={{ marginLeft: "8px", fontSize: "14px" }}>
                        {type.label}
                      </div>
                    </label>
                  ))}
                </div>

                {/* Course Plan Dropdown */}
                <div className="item2">
                  <DropDown
                    key={`course-plan-${planTypeId}`}
                    label="Course Plan"
                    selected={selectedCoursePlan}
                    setSelected={(opt) => {
                      setSelectedCoursePlan(opt || null);
                      setSubscriberId(null);
                      setSubscriberList([]);
                    }}
                    options={coursePlanOptions}
                    placeholder="Choose Course Plan..."
                    disabled={planTypeId === 1}
                    isRequired={planTypeId === 2}
                  />
                </div>

                {/* Subscriber Type Radios */}
                <div style={{ display: "flex", gap: "80px", gridColumn: "1/2" }}>
                  {[
                    { id: 1, label: "All Subscribers" },
                    { id: 2, label: "Specific Subscriber" },
                  ].map((type) => (
                    <label
                      key={type.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        color: "#6A6A6A",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        value={type.id}
                        checked={subscriberTypeId === type.id}
                        onChange={() => {
                          setSubscriberTypeId(type.id);
                          if (type.id === 1) {
                            setSubscriberId(null);
                            setSubscriberList([]);
                          }
                        }}
                      />
                      <div style={{ marginLeft: "8px", fontSize: "14px" }}>
                        {type.label}
                      </div>
                    </label>
                  ))}
                </div>

                {/* Subscriber Search Dropdown */}
                <div style={{ gridColumn: "2/3" }}>
                  <SubscriberSearchDropdown
                    key={`subscriber-${subscriberTypeId}-${planTypeId}-${selectedCoursePlan?.id ?? "all"}`}
                    label="Subscriber Name"
                    selected={subscriberId}
                    setSelected={setSubscriberId}
                    options={subscriberList}
                    placeholder="Search & select Subscriber's..."
                    width="100%"
                    onSearchInputChange={(searchKey) => {
                      setSubscriberSearchKey(searchKey);
                      if (searchKey?.trim()) {
                        fetchSubscribersBySearch(searchKey);
                      } else {
                        setSubscriberList([]);
                      }
                    }}
                    isDisabled={subscriberTypeId === 1}
                    isRequired={subscriberTypeId === 2}
                  />
                </div>

                {/* Message Title — maxLength 1000 */}
                <div style={{ gridColumn: "1/3" }}>
                  <FormInputs
                    label="Title"
                    type="text"
                    value={msgText}
                    onChange={(e) => setMsgText(e.target.value)}
                    placeholder="Enter message title..."
                    maxLength={1000}
                  />
                </div>

                <div className="item5" />

                {/* Message Textarea */}
                <div className="send_notification__message-wrapper">
                  <label className="send_notification__message-label">
                    Message <span className="send_notification__required">*</span>
                  </label>
                  <textarea
                    className="send_notification__textarea"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Write something..."
                    rows={5}
                  />
                </div>

              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SendNotification;